import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionRequirementServiceService extends BaseProvider {
	fileToLoad: any;
	requirementData:any;
  	constructor(  		
		public globals: GlobalsService,
 		public http: HttpClient,	
  	) { 
		super();

		this.baseUrl = "userProcessRequirementService";
	}

	getByParams(params){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 
					   this.baseUrl + 
					   '/requirement' +
					   `?requirementId=${params.requirementId}` + 
					   `&ProcessId=${params.processId}`;

	        this.http
	        .get(
	          this.url
	        )
	        .subscribe(
	            (data: any) => {
					this.requirementData = data;
	                resolve(data);
					
	            },
	            err => {reject(err)}
	        );
	    }); 		
	}	

	get(requirementId){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 
					   this.baseUrl + `?requirementId=${requirementId}`;

	        this.http
	        .get(
	          this.url
	        )
	        .subscribe(
	            (data: any) => {
					// this.requirementData = data;
	                resolve(data);
					
	            },
	            err => {reject(err)}
	        );
	    }); 		
	}	

	execute(requirementId){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 
					   this.baseUrl + `/${requirementId}`;

	        this.http
	        .post(
	          this.url,
	          null
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    }); 		
	}

	uploadRequirementFile(params){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/file';

	        this.http
	        .post(
	          this.url, 
	          params
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data.Data);
	            },
	            err => {reject(err)}
	        );
	    });   		
	}			
}
